import { OPERATIONS_PROBLEMS } from '@/data/operations';
import { ServiceProblems } from '../service/ServiceProblems';

export const ProblemsWeSolve = () => (
  <ServiceProblems
    data={OPERATIONS_PROBLEMS}
    accent="#FFB800"
    accentDark="#9C7400"
    accentSoft="#FFF3CC"
    index="02"
    discussHref="/?service=operations#solution-finder"
    testidPrefix="operations"
  />
);
